<template>
  <div>
    <router-link :to="to" :class="{'lg' : lg, 'sm' : sm, 'circular' : rounded }" class="btn btn-enlace shadow">
      <slot></slot>
    </router-link>
  </div>
</template>
<script>
export default {
  data() {
    return {
      lg: false,
      sm: false
    };
  },
  props: {
    to: String,
    size: String,
    rounded: Boolean
  },
  created() {
    if (this.size === "lg") {
      this.lg = true;
       this.sm = false;
    }else if(this.size === "sm"){
      this.sm = true;
      this.lg = false;
    } 
  }
};
</script>
<style scoped>
.btn-enlace {
  color: #fff !important;
  background: rgba(0, 156, 255, 1);
  font-size: calc(1.2em);
  font-weight: 500;
  padding: 7px 28px;
  letter-spacing: 0.1px;
  transition: transform 0.2s;
  -o-transition: transform 0.2s;
  -moz-transition: transform 0.2s;
  -webkit-transition: transform 0.2s;
}
.btn-enlace:hover {
  -webkit-transform: scale(1.055);
  -moz-transform: scale(1.055);
  -o-transform: scale(1.055);
  transform: scale(1.055);
}

.lg {
  padding: 12px 30px;
}
.sm {
  padding: 5px 18px;
}

.circular{
  border-radius: 50rem !important;
}
</style>